module.exports = __webpack_public_path__ + "static/img/btn3.182e2c3f.png";